const getEncountersWins = (encounters: Encounter[], opponentId: number) =>
  encounters.filter(encounter => encounter.winner_id === opponentId).length;

const getHalfScore = (opp: EncounterOpponent, halfIndex: number) =>
  opp.halves?.find(h => h.index === halfIndex)?.score ?? 0;

const getSubdivisionScore = (opp: EncounterOpponent, slug: EBattleSlug, index: number): number => {
  let subs: EBattleSubdivision[] | undefined;
  switch (slug) {
    case 'e-soccer':
      subs = opp.halves;
      break;
    case 'e-basketball':
      subs = opp.quarters;
      break;
    case 'e-hockey':
      subs = opp.periods;
      break;
    case 'e-tennis':
      subs = opp.sets;
      break;
  }
  return subs?.find(s => s.index === index)?.score ?? 0;
};

export { getEncountersWins, getHalfScore, getSubdivisionScore };
